import { ReactNode, FC } from 'react'

import { cn } from 'src/utils'

type SettingsFieldProps = {
  title?: ReactNode
  titleRight?: ReactNode
  description?: ReactNode
  children?: ReactNode
  className?: string
  required?: boolean
}

const SettingsField: FC<SettingsFieldProps> = ({
  title = '',
  titleRight = null,
  description = '',
  children = null,
  className = '',
  required = false,
}) => {
  return (
    <div
      className={cn('flex flex-row items-center justify-between', className)}
    >
      <div className="flex flex-col">
        <div className="flex flex-row items-center gap-1 text-sm font-medium">
          {title}
          {titleRight}
          {required && <span className="text-doubleNickel-error-500">*</span>}
        </div>
        <div className="text-xs text-doubleNickel-gray-500">{description}</div>
      </div>
      <div className="flex flex-row items-center gap-2 text-xs text-doubleNickel-gray-500 ">
        {children}
      </div>
    </div>
  )
}

export default SettingsField
